export {default} from './Sider';



// WEBPACK FOOTER //
// ./src/components/AuthLayout/Sider/index.ts